/* istanbul ignore file */
export interface StanConfig {
  displayName: string;
}

let configCache: StanConfig | null = null;

export const fetchStanConfig = async (): Promise<StanConfig> => {
  // Return cached config if available
  if (configCache) {
    return configCache;
  }

  try {
    // Fetch from the stan backend plugin's config endpoint
    const response = await fetch("/api/stan/config");
    if (!response.ok) {
      throw new Error(`Failed to fetch STAN config: ${response.statusText}`);
    }
    const data = await response.json();
    configCache = data as StanConfig;
    return configCache;
  } catch (error) {
    // Return default config when fetch fails
    return { displayName: "STAN" };
  }
};

export const clearStanConfigCache = () => {
  configCache = null;
};

export const getStanConfigSync = (): StanConfig => {
  return configCache ?? { displayName: "STAN" };
};
